import { render, staticRenderFns } from "./Repass.vue?vue&type=template&id=11244588&scoped=true"
import script from "./Repass.vue?vue&type=script&lang=js"
export * from "./Repass.vue?vue&type=script&lang=js"
import style0 from "./Repass.vue?vue&type=style&index=0&id=11244588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11244588",
  null
  
)

export default component.exports